import { render, staticRenderFns } from "./chevron-right.vue?vue&type=template&id=7f0417ac&"
import script from "./chevron-right.vue?vue&type=script&lang=js&"
export * from "./chevron-right.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/icons/chevron-right.vue
// module id = 1160
// module chunks = 0